<template>
    <div class="site_settings">
        <tabs>
            <tab name="Genel Ayarlar">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Genel Ayarlar</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="title">Site Başlığı <span class="charCounter"
                                                                                  :class="titleCharCounter > 65 ? 'active' : '' ">({{ titleCharCounter }})</span>
                                            </label>
                                            <input type="text" class="form-control custom-input" v-model="title"
                                                   @keyup="titleChar()">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="logo">Logo</label>
                                            <input type="file" class="form-control custom-input" @change="onLogo">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="description">SEO Description <span class="charCounter"
                                                                                           :class="descCharCounter > 160 ? 'active' : '' ">({{ descCharCounter }})</span></label>
                                            <input type="text" name="description" class="form-control custom-input"
                                                   v-model="description" @keyup="descChar()">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="keywords">SEO Keywords <span class="charCounter"
                                                                                     :class="commaCounter > 6 ? 'active' : '' ">({{ commaCounter }})</span></label>
                                            <input type="text" name="keywords" class="form-control custom-input"
                                                   v-model="keywords" @keyup="keywordsComma()">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="copyright">Copyright ©</label>
                                            <input type="text" class="form-control custom-input" v-model="copyright">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="about">Hakkımızda Yazısı</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="about"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="İletişim Ayarları">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>İletişim Ayarları</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="title">E-mail</label>
                                            <input type="text" class="form-control custom-input" v-model="email">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="member">Yetkili Kişi</label>
                                            <input type="text" class="form-control custom-input" v-model="member">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="land_phone">Sabit Telefon</label>
                                            <input type="text" class="form-control custom-input" v-model="land_phone">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="mobile_phone">Cep Telefonu</label>
                                            <input type="text" class="form-control custom-input" v-model="mobile_phone">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="address">Adres</label>
                                            <textarea cols="30" rows="10" class="form-control custom-input"
                                                      v-model="address"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Ana Sayfa">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Ana Sayfa İçeriği</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="home_title">Başlık</label>
                                            <input type="text" class="form-control custom-input" v-model="home_title">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="home_slogan">Slogan</label>
                                            <input type="text" class="form-control custom-input" v-model="home_slogan">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="home_spot">Spot
                                                <small>(Neden ve Nasıl Yurtlar Burada?)</small>
                                            </label>
                                            <textarea rows="7" class="form-control custom-input"
                                                      v-model="home_spot"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="blog_section_title">Blog Section Başlık</label>
                                            <textarea rows="7" class="form-control custom-input"
                                                      v-model="blog_section_title"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="blog_section_description">Blog Section Açıklama</label>
                                            <textarea rows="7" class="form-control custom-input"
                                                      v-model="blog_section_description"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="city_section_spot">Şehir Section Yazısı</label>
                                            <textarea rows="7" class="form-control custom-input"
                                                      v-model="city_section_spot"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Sosyal Medya">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Sosyal Medya Ayarları</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="facebook"> <i class="fab fa-facebook-square"></i>
                                                Facebook</label>
                                            <input type="text" class="form-control custom-input"
                                                   placeholder="https://facebook.com/example" v-model="facebook">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="twitter"><i class="fab fa-twitter-square"></i> Twtitter</label>
                                            <input type="text" class="form-control custom-input"
                                                   placeholder="https://twitter.com/example" v-model="twitter">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="instagram"><i class="fab fa-instagram"></i> Instagram</label>
                                            <input type="text" class="form-control custom-input"
                                                   placeholder="https://instagram.com/example" v-model="instagram">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="linkedin"><i class="fab fa-linkedin"></i> Linkedin</label>
                                            <input type="text" class="form-control custom-input"
                                                   placeholder="https://linkedin.com/in/example" v-model="linkedin">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
        </tabs>
        <div class="row">
            <div class="col-md-12">
                <div class="widget text-center">
                    <div class="form-elements-sec">
                        <button class="btn btn-success" @click="updateData">Kaydet</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {VueEditor} from "vue2-editor";

    export default {
        components: {VueEditor},
        data() {
            return {
                customToolbar: [
                    ['bold', 'italic', 'underline'],
                    [{'list': 'ordered'}, {'list': 'bullet'}]
                ],
                id: '1',
                logo: '',
                title: '',
                keywords: '',
                description: '',
                home_title: '',
                home_slogan: '',
                home_spot: '',
                blog_section_title: '',
                blog_section_description: '',
                city_section_spot: '',
                copyright: '',
                home_bg: '',
                about: '',
                member: '',
                land_phone: '',
                mobile_phone: '',
                fax: '',
                address: '',
                email: '',
                facebook: '',
                twitter: '',
                instagram: '',
                linkedin: '',
                api: 'settings/',

            }
        },
        created() {
            this.getData()
        },
        methods: {
            titleChar() {
                this.titleCharCounter = this.title.length
            },
            descChar() {
                this.descCharCounter = this.description.length
            },
            keywordsComma() {
                this.commaCounter;
            },
            onLogo(event) {
                this.logo = event.target.files[0]
                // console.log(this.logo)
            },
            getData() {
                this.axios.get(this.api).then(response => {
                    this.title = response.data.title
                    this.keywords = response.data.keywords
                    this.description = response.data.description
                    this.about = response.data.about
                    this.member = response.data.member
                    this.land_phone = response.data.land_phone
                    this.mobile_phone = response.data.mobile_phone
                    this.fax = response.data.fax
                    this.address = response.data.address
                    this.email = response.data.email
                    this.home_title = response.data.home_title
                    this.home_slogan = response.data.home_slogan
                    this.home_spot = response.data.home_spot
                    this.blog_section_title = response.data.blog_section_title
                    this.blog_section_description = response.data.blog_section_description
                    this.city_section_spot = response.data.city_section_spot
                    this.copyright = response.data.copyright
                    this.facebook = response.data.facebook
                    this.twitter = response.data.twitter
                    this.instagram = response.data.instagram
                    this.linkedin = response.data.linkedin
                })
            },
            updateData() {
                this.$Progress.start()
                var data = {
                    title: this.title || '' ,
                    keywords: this.keywords || '' ,
                    description: this.description || '' ,
                    about: this.about || '' ,
                    member: this.member || '' ,
                    land_phone: this.land_phone || '' ,
                    mobile_phone: this.mobile_phone || '' ,
                    fax: this.fax || '' ,
                    address: this.address || '' ,
                    email: this.email || '' ,
                    home_title: this.home_title || '' ,
                    home_slogan: this.home_slogan || '' ,
                    home_spot: this.home_spot || '' ,
                    blog_section_title: this.blog_section_title || '' ,
                    blog_section_description: this.blog_section_description || '' ,
                    city_section_spot: this.city_section_spot || '' ,
                    copyright: this.copyright || '' ,
                    facebook: this.facebook || '' ,
                    twitter: this.twitter || '' ,
                    instagram: this.instagram || '' ,
                    linkedin: this.linkedin || '' ,
                }
                const formData = new FormData();
                formData.append('logo', this.logo)
                Object.keys(data).map(e => {
                    formData.append(e, data[e])
                })
                this.axios.post(this.api + this.id, formData)
                    .then(response => {
                        if (response.status == 200) {
                            this.$Progress.finish()
                        }
                    })
            }
        },
        computed: {
            titleCharCounter() {
                return this.title.length
            },
            descCharCounter() {
                return this.description.length
            },
            commaCounter() {
                var comma = this.keywords.split(',').length;
                return comma;
            }
        },
    }
</script>

<style scoped>
    .editor {
        height: 400px;
        margin-bottom: 50px;
    }

    .charCounter {
        font-weight: normal;
        color: #666;
    }

    .charCounter.active {
        color: red;
    }
</style>
